const normalizeInteger = (value) => {
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

export const normalizeQuantity = (value, fallback = 1) => {
  const parsed = normalizeInteger(value);
  return parsed !== null && parsed >= 1 ? parsed : fallback;
};

export const buildKitIdentitySuggestion = (components) => {
  const names = (components || [])
    .map((component) => String(component?.title || component?.sku || '').trim())
    .filter(Boolean)
    .slice(0, 2);
  const title = names.length > 0 ? `Kit ${names.join(' + ')}`.slice(0, 255) : 'Kit nuevo';
  const skuParts = (components || [])
    .map((component) => String(component?.sku || component?.title || '').trim())
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/^-|-$/g, ''))
    .filter(Boolean);
  return {
    title,
    sku: skuParts.length > 0 ? `KIT-${skuParts.join('-')}`.slice(0, 255) : 'KIT-NUEVO',
  };
};

export const getComponentInitialStock = (component) => {
  if (component?.stockInWarehouse !== null && component?.stockInWarehouse !== undefined) {
    return null;
  }
  const parsed = normalizeInteger(component?.initialStock);
  return parsed !== null && parsed >= 0 ? parsed : null;
};

export const getKitCreationValidation = ({ listingId, warehouseId, components, title, sku }) => {
  if (!listingId) return 'Selecciona una publicación para configurar el kit.';
  if (!warehouseId) return 'Selecciona un depósito para continuar.';
  if ((components || []).length < 2) return 'Agrega al menos 2 productos para crear un kit.';
  const invalidQuantity = (components || []).find((component) => normalizeInteger(component?.quantity) === null || Number(component.quantity) < 1);
  if (invalidQuantity) return 'Ingresa una cantidad entera mayor o igual a 1.';
  const missingStock = (components || []).find(
    (component) =>
      (component?.stockInWarehouse === null || component?.stockInWarehouse === undefined) &&
      getComponentInitialStock(component) === null,
  );
  if (missingStock) {
    return `Completa el stock inicial de ${missingStock.title || 'este producto'}.`;
  }
  if (!String(title || '').trim()) return 'Ingresa un título para el kit.';
  if (!String(sku || '').trim()) return 'Ingresa un SKU para el kit.';
  return null;
};

export const buildKitPayload = ({ listingId, warehouseId, components, title, sku, associateMatchingSkuListings, publishCalculatedStock }) => ({
  ...(listingId ? { listingId } : {}),
  warehouseId,
  title: String(title || '').trim(),
  sku: String(sku || '').trim(),
  ...(associateMatchingSkuListings !== undefined ? { associateMatchingSkuListings: Boolean(associateMatchingSkuListings) } : {}),
  ...(publishCalculatedStock !== undefined ? { publishCalculatedStock: Boolean(publishCalculatedStock) } : {}),
  components: (components || []).map((component) => {
    const initialStock = getComponentInitialStock(component);
    return {
      itemId: component.id,
      quantity: normalizeQuantity(component.quantity),
      ...(initialStock !== null ? { initialStock } : {}),
    };
  }),
});
